import { Link } from "react-router-dom";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  kicker,
  title,
  subtitle,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {kicker && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-50 px-3 py-1 text-xs font-medium tracking-wide text-accent-700">
            <i className="ri-bookmark-3-line" />
            {kicker}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {subtitle && (
          <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-500">{subtitle}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}